<div class="flex flex-row justify-between ticket-wrapper white-bg">
  <div class="flex ticket flex flex-col justify-between p-8">
    <div class="mat-h3 mb-0 text-overflow-ellipsis">{{ticket.key}}</div>
    <div class="mat-body mb-4 text-overflow-ellipsis">{{ticket.summary}}</div>
    <div class="flex flex-row justify-center created-on">
      <span>{{(ticket.created | date: 'dd.MM.yyyy, H:mm a' | lowercase) + ' | '}}</span>
      <span [ngClass]="statusClass[ticket.status]" class="status ml-4"></span>
      <span class="ml-8">{{'TICKETS.STATUS.' + ticket.status | transloco}}</span>
    </div>
  </div>
  <div class="flex items-center expand cursor-pointer ticket-icon">
    <mat-icon svgIcon="arrow_upward"></mat-icon>
  </div>
</div>
